import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  header: {
    color: theme.palette.textcolor.main,
    textTransform: 'uppercase',
    fontSize: '1.4375em',
    fontStyle: 'italic',
    marginBottom: 10,
  },
  text: {
    color: '#000000',
    display: 'block',
    maxWidth: 700,
  },
  chartsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 30,
  },
  chartsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  chartTitle: {
    textTransform: 'uppercase',
    color: '#000000',
    fontFamily: 'Source Sans Pro, sans-serif',
    textAlign: 'center',
    marginBottom: -5,
  },
  kpis: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 20,
    marginTop: 20,
  },
  kpi: {
    textAlign: 'center',
  },
  kpiNumber: {
    color: theme.palette.primary.main,
    fontSize: '2.5em',
    fontWeight: 900,
    fontFamily: 'Playfair Display, serif',
    paddingBottom: 5,
  },
  kpiText: {
    fontSize: '0.55em',
    // textTransform: 'uppercase',
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.5em',
    },
  },
  kpiValue: {
    fontSize: '1.3em',
    fontWeight: '700',
    marginBottom: 2,
    // textTransform: 'uppercase',
    display: 'block',
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.2em',
    },
  },
  divider: {
    marginTop: 5,
    height: 5,
    backgroundColor: '#75798E',
    width: '100%',
  },
}));

export default useStyles;
